import { getDateByFormat } from 'helpers/time-format'

export const isDateInAppointments = ({ appointmentDate: { date = '', time: { value } = {}} = {}, dates = {}}) => {
  const [monthYear = '', day = ''] = (getDateByFormat({ date, format: 'MM/YYYY DD' }) || '').split(' ') || []

  const {
    [monthYear]: {
      [day]: [
        ...slots
      ] = []
    } = {}
  } = dates || {}

  return !!date && (slots || [{}]).some(({ value: slotValue }) => !!slotValue && slotValue === value)
}

export const formatPhoneNumber = phoneNumber =>
  phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, (match, p1, p2, p3) => `(${p1}) ${p2} - ${p3}`)
